import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, type Brand } from "@/api/client";
import { useAuth } from "@/auth/AuthProvider";

export function Dashboard() {
  const { me } = useAuth();
  const { t, i18n } = useTranslation();
  const brands = useQuery({ queryKey: ["brands"], queryFn: () => api<Brand[]>("/app/brands") });
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">{t("dashboard.welcome", { name: me?.name })}</h1>
      <p className="text-gray-500">{t("dashboard.phase")}</p>
      <section>
        <h2 className="font-medium mb-2">{t("dashboard.brands")}</h2>
        <ul className="grid gap-3 sm:grid-cols-2">
          {brands.data?.map((b) => (
            <li key={b.id} className="rounded-xl border bg-white p-4">
              <div className="font-semibold">{b.name[i18n.language] ?? b.name.el}</div>
              <div className="text-sm text-gray-500">{b.domain} · {b.booking_mode} · {b.stores.length} stores</div>
              <Link className="text-sm text-brand underline" to={`/app/settings/brand/${b.id}`}>{t("nav.settings")}</Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
